import type { HTMLAttributes, ReactNode } from "react";
import { Icon } from "../icons";
import type { IconName } from "../icons";
import { Button } from "./Button";

export type ChipTone = "neutral" | "accent" | "selection" | "measure" | "success" | "warning" | "danger" | "dark";

export type ChipProps = HTMLAttributes<HTMLSpanElement> & {
  tone?: ChipTone;
  icon?: IconName | null;
  mono?: boolean;
  onRemove?: (() => void) | null;
  removeLabel?: string;
  children: ReactNode;
};

export function Chip({ tone = "neutral", icon = null, mono = false, onRemove = null, removeLabel = "", className, children, ...rest }: ChipProps) {
  return (
    <span {...rest} className={["fxmap-chip", `fxmap-chip-${tone}`, mono ? "fxmap-mono" : "fxmap-tabular", className ?? ""].filter(Boolean).join(" ")}>
      {icon !== null ? <Icon name={icon} /> : null}
      <span className="fxmap-chip-text">{children}</span>
      {onRemove !== null ? <Button kind="icon" size="sm" icon="close" label={removeLabel} className="fxmap-chip-remove" onClick={onRemove} /> : null}
    </span>
  );
}
